"use client";

import { Textarea } from "@/components/ui/textarea";
import { StepProps, BaseFormData } from "../components/types";
import parse from "html-react-parser";
import { useFormContext } from "react-hook-form";
import { FormField, FormItem, FormControl, FormLabel, FormMessage } from "@/components/ui/form";

type TextFieldStepProps<T = BaseFormData> = StepProps<T>;

export const TextFieldStep = <T extends BaseFormData = BaseFormData>({ title, description, formData }: TextFieldStepProps<T>) => {
  const { control, formState } = useFormContext();
  const businessName = (formData.tradingName && typeof formData.tradingName === 'string' ? formData.tradingName : null) || 
                       (formData.businessName && typeof formData.businessName === 'string' ? formData.businessName : null) || 
                       "your company";

  return (
    <div className="flex flex-col gap-12">
      {/* Main Title */}
      <div className="flex flex-col gap-4">
        <h3>
          {title}
        </h3>
        {description && (
          <p className="paragraph-lg text-foreground">
            {businessName && <strong>Tell us about what <span className="text-brand">{businessName}</span> does.</strong>} {parse(description)}
          </p>
        )}
      </div>

      {/* Business Description Field */}
      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-2">
          <FormField
            control={control}
            name={"businessDescription" as never}
            render={({ field }) => {
              const businessDescriptionValue = (field.value as string) || "";
              const characterCount = businessDescriptionValue.length;
              const maxLength = 4000;
              
              return (
                <FormItem>
                  <FormLabel>Business Description <span className="font-normal text-muted-foreground">(Optional)</span></FormLabel>
                  <FormControl>
                    <Textarea
                      {...field}
                      value={businessDescriptionValue}
                      onChange={(e) => { field.onChange(e); }}
                      placeholder=""
                      maxLength={maxLength}
                      className="min-h-[120px]"
                    />
                  </FormControl>
                  <div className="flex justify-between gap-2">
                    <div className="flex-1 min-w-0">
                      {formState.errors.businessDescription ? (
                        <FormMessage />
                      ) : (
                        <p className="paragraph-sm text-muted-foreground">
                          Describe your main products or services so we can better understand your business.
                        </p>
                      )}
                    </div>
                    <p className="paragraph-sm text-muted-foreground whitespace-nowrap flex-shrink-0">
                      {characterCount} / {maxLength}
                    </p>
                  </div>
                </FormItem>
              );
            }}
          />
        </div>
      </div>

    </div>
  );
}; 